module.exports = __webpack_public_path__ + "static/img/sy_3.f6a6181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_3.png
// module id = qqbe
// module chunks = 1